import { render, staticRenderFns } from "./miaosha.vue?vue&type=template&id=1316a7ac&"
import script from "./miaosha.vue?vue&type=script&lang=js&"
export * from "./miaosha.vue?vue&type=script&lang=js&"
import style0 from "./miaosha.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports